"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledImage = void 0;
var _Image = require("./Image");
// TODO: in v9, move styled() from Image.jsx to here
var StyledImage = _Image.Image;
exports.StyledImage = StyledImage;